<template>
  <input
    class="inputCustomerPhone inputstyle col-md-4 fontSize16"
    type="text"
    required="required"
    :value="customerPhone"
    @input="updateCustomerPhone($event)"
    @keydown.stop.prevent.enter="$emit('searchCustomerInfo')"
  />
</template>
<script>
export default {
  props: {
    customerPhone: {
      required: true,
    },
  },
  methods: {
    updateCustomerPhone($event) {
      const { value } = $event.target
      this.$emit('updateCustomerPhone', value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/input/InputCustomerPhone.vue